React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')()
ApiError = require 'network/api-error'
Auth = require 'db/auth'
Controller = require 'controller'
Card = require 'models/card'
Board = require 'models/board'
List = require 'models/list'
Organization = require 'models/organization'
ModelLoader = require 'db/model-loader'
startDecayingInterval = require 'lib/util/decaying-interval'
TFM = require 'lib/markdown/tfm'
Util = require 'lib/util'
Alerts = require 'views/lib/alerts'
ApiPromise = require 'network/api-promise'
Promise = require 'bluebird'
HomeUpNextComponent = require 'views/home/home-up-next-component'
HomeActivityFeedComponent = require 'views/home/home-activity-feed-component'
HomeOrientationComponent = require 'views/home/home-orientation-component'
HomeNewUserComponent = require 'views/home/home-new-user-component'

module.exports = class HomeMainContentContainer extends React.Component
  displayName: 'HomeMainContentContainer'

  constructor: (props) ->
    super props

    @dismissTimeout = null
    @nextPollCallbacksUpNext = []
    @onHomeTab = !@props.orgname # no orgname means it's on home tab

    @updateUpNextCards = @updateUpNextCards.bind(@)
    @fetchUpNextCards = @fetchUpNextCards.bind(@)
    @startPollingForUpNextCards = @startPollingForUpNextCards.bind(@)
    @onNextPollUpNext = @onNextPollUpNext.bind(@)
    @nextPollCallbackUpNext = @nextPollCallbackUpNext.bind(@)
    @optimisticallyDismissCard = @optimisticallyDismissCard.bind(@)
    @dismissUpNextOrientationCard = @dismissUpNextOrientationCard.bind(@)
    @dismissUpNextCard = @dismissUpNextCard.bind(@)

    @fetchActivities = @fetchActivities.bind(@)
    @renderActivities = @renderActivities.bind(@)
    @startPollingforActivities = @startPollingforActivities.bind(@)
    @showUnreadActions = @showUnreadActions.bind(@)
    @loadMoreActivities = @loadMoreActivities.bind(@)
    @dismissHighlightsOrientationCard = @dismissHighlightsOrientationCard.bind(@)

    @dismissNewUser = @dismissNewUser.bind(@)
    @createBoard = @createBoard.bind(@)

    @state = {
      isFirstBoard: false
      showNewUserCard: false
      newUserCanDismiss: false
      upNextCards: []
      optimisticallyDismissedCardIds: {}
      actions: []
      mostRecentActionId: ''
      unreadActions: []
      loadingMore: false
      moreHighlightsLength: 0
      initialUpNextLoad: false
      initialHighlightsLoad: false
    }

  componentDidMount: ->
    ModelLoader.waitFor 'boardsData', =>
      me = Auth.me()
      ownedBoards = _.filter me.boardList.models, (board) -> board.owned()
      openBoards = _.filter me.boardList.models, (board) -> board.isOpen()
      orgsMemberOf = _.filter me.organizationList.models, (member) -> member.isMember(me)

      # Only has a welcome board or no boards at all
      isFirstBoard = (ownedBoards.length == 0 || (ownedBoards.length == 1 && ownedBoards[0].isWelcomeBoard()))
      hasOrgOrBoard = openBoards.length > 1 || orgsMemberOf.length > 0

      showNewUserCard = isFirstBoard && !Auth.me().isDismissed('homeNewUserCard')
      newUserCanDismiss = showNewUserCard && hasOrgOrBoard

      @setState
        isFirstBoard: isFirstBoard
        showNewUserCard: showNewUserCard
        newUserCanDismiss: newUserCanDismiss

      if !showNewUserCard
        if @onHomeTab
          @fetchUpNextCards().then (upNextCards) =>
            @setState upNextCards: upNextCards
            @startPollingForUpNextCards()
          .catch (e) => console.error e
          .finally =>
            @setState
              initialUpNextLoad: true
        else
          @setState
            initialUpNextLoad: true

        @fetchActivities({}).then (actions) =>
          @setState
            actions: actions
            mostRecentActionId: if actions?.length then actions[0].id else ''
          @startPollingforActivities()
        .catch (e) => console.error e
        .finally =>
          @setState
            initialHighlightsLoad: true
      else
        @setState
          initialUpNextLoad: true
          initialHighlightsLoad: true

  componentWillUnmount: ->
    if @cancelUpNextDecayingInterval
      @cancelUpNextDecayingInterval()

    if @cancelHighlightsDecayingInterval
      @cancelHighlightsDecayingInterval()

    if @dismissTimeout
      clearTimeout(@dismissTimeout)

  # Up Next Functions Start
  updateUpNextCards: (callback) ->
    @fetchUpNextCards().then (upNextCards) =>
      @setState upNextCards: upNextCards, callback

  fetchUpNextCards: ->
    { modelCache } = @props

    ModelLoader.loadUpNext()
      .then (upNextItems) =>
        upNextItems
          .filter (upNextItem) ->
            card = upNextItem.data?.card
            return card && card?.board && card?.list && upNextItem.items?.length
          .map (upNextItem) ->
            card = upNextItem.data?.card
            board = card?.board
            org = board?.organization
            list = card?.list
            item = upNextItem.items[0] # for initial release there is only 1 item

            return {
              id: upNextItem.id
              card: new Card(card, modelCache: modelCache)
              board: new Board(board, modelCache: modelCache)
              org: new Organization(org, modelCache: modelCache)
              list: new List(list, modelCache: modelCache)
              item
            }

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        console.error e
        []

  startPollingForUpNextCards: ->
    @cancelUpNextDecayingInterval = startDecayingInterval =>
      @updateUpNextCards(@nextPollCallbackUpNext())

  onNextPollUpNext: (callback) ->
    @nextPollCallbacksUpNext.push callback

  nextPollCallbackUpNext: ->
    if @nextPollCallbacksUpNext.length == 0
      return _.noop

    callbacks = @nextPollCallbacksUpNext.slice()
    @nextPollCallbacksUpNext = []
    -> callbacks.map (callback) -> callback()

  optimisticallyDismissCard: (cardId) ->
    # optimistically dismiss card with a slight delay
    @dismissTimeout = setTimeout (=>
      @setState (prevState, props) ->
        optimisticallyDismissedCardIds:
          _.extend {}, prevState.optimisticallyDismissedCardIds, { "#{cardId}": true }
    ), 250

  dismissUpNextOrientationCard: ->
    Auth.me().dismiss('homeUpNextOrientationCard')

  dismissUpNextCard: (cardId, upNextId) ->
    @optimisticallyDismissCard(cardId)

    ApiPromise
      url: "1/members/me/upNext/#{upNextId}"
      type: 'DELETE'
    .then =>
      # Dismissed cards won't be included in the next poll, which means they
      # no longer need to be optimistically hidden.
      @onNextPollUpNext => @setState (prevState, props) ->
        optimisticallyDismissedCardIds:
          _.omit prevState.optimisticallyDismissedCardIds, cardId
    .done()
  # Up Next Functions End

  # Highlights Functions Start
  fetchActivities: ({ before, since }) ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    if (orgname && !orgId)
      # if there is no orgId when there is an orgname it means that you no longer can see that team
      # this fixes an issue when you're deactivated from a team, but the update to the model hasn't
      # flown down and redirected the page, so we make a bad request by fetching highlights for that team
      return new Promise (resolve) -> []

    ModelLoader.loadHighlights({ before, since, organization: orgId })
      .then (actions) =>
        actions.map (action) =>
          {
            id: action.id
            card: new Card(action.get('card'), modelCache: @props.modelCache),
            memberCreator: @props.modelCache.get('Member', action.get('idMemberCreator'))
            isAddAttachment: action.isAddAttachment(),
            isCommentLike: action.isCommentLike(),
            entity:
              type: 'comment'
              textHtml: TFM.comments.format(action.get('data').text).output
              date: action.get('date')
              isEdited: !!action.get('data').dateLastEdited
          }
      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        console.error e
        []

  renderActivities: ->
    @fetchActivities({ since: @state.mostRecentActionId }).then (newActions) =>
      if newActions.length
        @setState (prevState, props) ->
          unreadActions: newActions.concat prevState.unreadActions
          mostRecentActionId: newActions[0].id

  startPollingforActivities: ->
    @cancelHighlightsDecayingInterval = startDecayingInterval(@renderActivities)

  showUnreadActions: (e) ->
    Util.preventDefault(e)

    @setState (prevState, props) ->
      actions: prevState.unreadActions.concat prevState.actions
      unreadActions: []
      mostRecentActionId: prevState.unreadActions[0].id

  loadMoreActivities: (e) ->
    Util.preventDefault(e)

    @setState
      loadingMore: true
    @fetchActivities({ before: @state.actions[@state.actions.length - 1].id }).then (actions) =>
      @setState (prevState, props) ->
        actions: prevState.actions.concat(actions)
        moreHighlightsLength: actions.length
    .catch (e) => console.error e
    .finally =>
      @setState
        loadingMore: false

  dismissHighlightsOrientationCard: ->
    Auth.me().dismiss('homeHighlightsOrientationCard')
  # Highlights Functions End

  dismissNewUser: ->
    Auth.me().dismiss('homeNewUserCard')

  createBoard: (name) ->
    # can only create a private personal board
    # so setting idOrganization, prefs_permissionLevel, and prefs_selfJoin to defaults

    { isFirstBoard } = @state

    # Data that we'll use in the body of the POST to create the board
    initialData = {
      name
      idOrganization: ''
    }

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: false
      defaultLists: isFirstBoard
    }, initialData)

    newBoard = Auth.me().boardList.create initialData, {
      @modelCache
      requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we get the board id back before we can
        # display the board
        Controller.displayBoard({
          idBoard: board.id
          openListComposer: !isFirstBoard
          openCardComposerInFirstList: isFirstBoard
        }).done()

        return
      error: ->
        Alerts.flash('could not create board', 'error', 'create error')
    }

  render: t.renderable ->
    {
      showNewUserCard
      newUserCanDismiss
      actions
      unreadActions
      loadingMore
      moreHighlightsLength
      upNextCards
      optimisticallyDismissedCardIds
      initialUpNextLoad
      initialHighlightsLoad
    } = @state

    t.div '.home-main-content-container', =>
      if showNewUserCard
        t.tag HomeNewUserComponent, {
          title: 'orientation-new-user-title'
          text: 'orientation-new-user-text'
          backgroundClass: 'home-orientation-new-user-background'
          modelCache: @props.modelCache
          onCreateBoardClick: @createBoard
          onDismissClick: if newUserCanDismiss then @dismissNewUser
        }

      else
        if !initialUpNextLoad || !initialHighlightsLoad
          t.div ->
            t.div '.spinner.loading'

        else if !upNextCards.length && !actions.length
          t.tag HomeOrientationComponent, {
            title: 'orientation-no-content-title'
            text: 'orientation-no-content-text'
            backgroundClass: 'home-orientation-no-content-background'
            backgroundTop: true
          }

        else
          if @onHomeTab
            t.tag HomeUpNextComponent, {
              upNextCards
              @optimisticallyDismissCard
              @dismissUpNextOrientationCard
              optimisticallyDismissedCardIds
              dismissCard: @dismissUpNextCard
              modelCache: @props.modelCache
            }

          t.tag HomeActivityFeedComponent, {
            @loadMoreActivities
            @showUnreadActions
            @onHomeTab
            @dismissHighlightsOrientationCard
            actions
            unreadActions
            loadingMore
            moreHighlightsLength
            memberCreator: @props.modelCache.get('Member', Auth.myId())
            organizationList: Auth.me()?.organizationList?.models
          }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-main-content-container.coffee